// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFlat_root__3ByOC"};